export default __webpack_public_path__ + "static/media/webjam.f88865a5.png";